import { Injectable } from '@angular/core';
import { Subject  } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModulePermission {
  permissionData: Subject<any>;

  constructor() {
    this.permissionData = new Subject<any>();
  }
}
